import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ${isScrolled ? 'bg-primary-600 shadow-lg backdrop-blur-lg bg-opacity-90' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* לוגו */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center hover:opacity-90 transition-all duration-300">
              <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-md">
                <span className="text-primary-600 font-bold text-2xl">D.I</span>
              </div>
              <div className="text-white mr-4">
                <span className="text-xl font-bold block leading-tight">D.I.Technologies</span>
                <span className="text-sm text-primary-100 block mt-0.5">ד.י.טכנולוגיה</span>
              </div>
            </Link>
          </div>

          {/* תפריט רגיל למסך רחב */}
          <div className="hidden md:flex md:items-center">
            <div className="flex space-x-1 items-center">
              <Link to="/" className="nav-link mx-3">
                דף הבית
              </Link>
              <Link to="/about" className="nav-link mx-3">
                אודות
              </Link>
              <Link to="/services" className="nav-link mx-3">
                שירותים
              </Link>
              <Link to="/contact" className="nav-link mx-3">
                צור קשר
              </Link>
            </div>
          </div>
          
          {/* תפריט המבורגר למובייל */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="inline-flex items-center justify-center p-2.5 rounded-xl text-white hover:bg-white/10 focus:outline-none transition-all duration-300"
              aria-expanded={isOpen}
            >
              <span className="sr-only">פתח תפריט</span>
              <svg
                className={`${isOpen ? 'hidden' : 'block'} nav-icon`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
              <svg
                className={`${isOpen ? 'block' : 'hidden'} nav-icon`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* תפריט נייד */}
        <div className={`${isOpen ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'} md:hidden overflow-hidden transition-all duration-500 ease-in-out`}>
          <div className="px-2 pt-2 pb-3 space-y-1">
            <Link
              to="/"
              className="nav-link block py-2.5 px-4 text-center"
              onClick={() => setIsOpen(false)}
            >
              דף הבית
            </Link>
            <Link
              to="/about"
              className="nav-link block py-2.5 px-4 text-center"
              onClick={() => setIsOpen(false)}
            >
              אודות
            </Link>
            <Link
              to="/services"
              className="nav-link block py-2.5 px-4 text-center"
              onClick={() => setIsOpen(false)}
            >
              שירותים
            </Link>
            <Link
              to="/contact"
              className="nav-link block py-2.5 px-4 text-center"
              onClick={() => setIsOpen(false)}
            >
              צור קשר
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 